module.exports = __webpack_public_path__ + "img/1588974569.1ad8877b.png";